import actions from './oktaFederations.actions'
import mutations from './oktaFederations.mutations'

const state = {
  federations: [],
  federationSsoGroups: null
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
